import React from 'react';
import { ClerkProvider } from '@clerk/clerk-react';
import { ParallaxProvider } from 'react-scroll-parallax';
import SiteProvider from './src/context/SiteContext';

export const wrapPageElement = ({ element }) => {
  return (
    <ParallaxProvider>
      <ClerkProvider
        publishableKey={process.env.GATSBY_CLERK_PUBLISHABLE_KEY}
        afterSignOutUrl="/login/"
      >
        <SiteProvider>{element}</SiteProvider>
      </ClerkProvider>
    </ParallaxProvider>
  );
};

export const onRouteUpdate = () => {
  if (typeof window !== 'undefined' && window.grecaptcha) {
    window.grecaptcha.execute(process.env.GATSBY_GOOGLE_RECAPTURE_SITE_KEY, {
      action: 'page_view',
    });
  }
};
